import styles from './Event_25.module.css'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import img1 from "./Memories_Images/1.jpg";
import img2 from "./Memories_Images/2.jpg";
import img3 from "./Memories_Images/3.jpg";
import img4 from "./Memories_Images/4.jpg";
import img5 from "./Memories_Images/5.jpg";
import img6 from "./Memories_Images/6.jpg";
import img7 from "./Memories_Images/7.jpg";


const AboutCarousel = () =>{
    return (
        <>
        < Carousel
        autoPlay={true}
        infiniteLoop={true}
        interval={3000}
        showArrows={true}
        showThumbs={false}
        showIndicators={false}
    >
    <div className={styles.container}>
    <img src={img1} alt="Memory1" />
    </div>
    <div className={styles.container}>
    <img src={img2} alt="Memory2" />
    </div>
    <div className={styles.container}>
    <img src={img3} alt="Memory3" />
    </div>
    <div className={styles.container}>
    <img src={img4} alt="Memory4" />
    </div>
    <div className={styles.container}>
    <img src={img5} alt="Memory5" />
    </div>
    <div className={styles.container}>
    <img src={img6} alt="Memory6" />
    </div>
    <div className={styles.container}>
    <img src={img7} alt="Memory7" />
    </div>
    </Carousel>
        </>
    );
}

export default AboutCarousel;

